/**
 * Sales Channel Constants
 *
 * Output-layer transformation only — converts net-to-artist prices to retail.
 * Does NOT enter the pricing engine. TTCP, ceiling, forensic gates are channel-agnostic.
 * Source: P10 remediation.
 */

export type SalesChannelKey = 'direct' | 'gallery' | 'online_platform' | 'consignment';

export const SALES_CHANNEL_KEYS: SalesChannelKey[] = ['direct', 'gallery', 'online_platform', 'consignment'];

export interface ChannelConfig {
  rate: number;    // Commission rate (0.0–1.0). Gallery 0.50 = gallery takes 50%.
  label: string;   // User-facing label with percentage.
}

export const CHANNEL_COMMISSION: Record<SalesChannelKey, ChannelConfig> = {
  direct:          { rate: 0.00, label: 'Direct to Buyer' },
  gallery:         { rate: 0.50, label: 'Gallery (50%)' },
  online_platform: { rate: 0.35, label: 'Online Platform (35%)' },
  consignment:     { rate: 0.40, label: 'Consignment (40%)' },
};

/**
 * Compute retail price from net price and commission rate.
 * retailPrice = netPrice / (1 - commissionRate)
 * Returns net price unchanged for direct channel (rate = 0).
 */
export function computeRetailPrice(netCents: number, channel: SalesChannelKey = 'direct'): number {
  const { rate } = CHANNEL_COMMISSION[channel];
  if (rate <= 0) return netCents;
  return Math.round(netCents / (1 - rate));
}
